// extracted by mini-css-extract-plugin
module.exports = {"columns":"CommonSettings_columns__2wEwD","column":"CommonSettings_column__YKO25"};